const Firmas = () =>{

    return(
        <div className='firmas'>
            <hr/>
            <div className="contenedor-firmas">
                <img src="/img/git.png" className="log" alt="logo-github"/>
                <a href="https://github.com/gissestephy" className="links link-secondary text-light fw-bold text-decoration-none">
                    <img className="img-mostrar" src='https://avatars.githubusercontent.com/u/103209971?v=4' alt="img-perfil"/>
                    <p className="nombres">Gisela Colmeiro</p>
                </a>
                <img src="/img/git.png" className="log" alt="logo-github"/>
                <a href="https://github.com/JuanGabrielChaves" className="links link-secondary text-light fw-bold text-decoration-none">
                    <img className="img-mostrar" src='https://avatars.githubusercontent.com/u/88752030?v=4' alt="img-perfil"/>
                    <p className="nombres">Gabriel Chaves</p>
                </a>
                <img src="/img/git.png" className="log" alt="logo-github"/>
                <a href="https://github.com/sofiamfernandez" className="links link-secondary text-light fw-bold text-decoration-none">
                    <img className="img-mostrar" src='https://avatars.githubusercontent.com/u/68400669?v=4' alt="img-perfil"/>
                    <p className="nombres">Sofia Fernandez</p>
                </a>
                <img src="/img/git.png" className="log" alt="logo-github"/>
                <a href="https://github.com/Dvdcom" className="links link-secondary text-light fw-bold text-decoration-none">
                    <img className="img-mostrar" src='https://avatars.githubusercontent.com/u/105727909?v=4'alt="img-perfil"/>
                    <p className="nombres">David Gutierrez</p>
                </a>
                <img src="/img/git.png" className="log" alt="logo-github"/>
                <a href="https://github.com/daianaryan" className="links link-secondary text-light fw-bold text-decoration-none">
                    <img className="img-mostrar" src='https://avatars.githubusercontent.com/u/88803959?v=4' alt="img-perfil"/>
                    <p className="nombres">Daiana Ryan</p>
                </a>
            </div>
        </div>
    );
}
    
export default Firmas;